type HandlerGroup = {
  apply: null | (() => Promise<void>);
  clear: null | (() => void);
  toggle: null | ((type: "connect2D" | "point") => void);
};

export const createHandlers = (): HandlerGroup => ({
  apply: null,
  clear: null,
  toggle: null,
});


const segmentTypes = ["connect"] as const;

type SegmentManagerType = (typeof segmentTypes)[number];

export const segmentManagerStore: Record<SegmentManagerType, HandlerGroup> =
  Object.fromEntries(
    segmentTypes.map((type) => [type, createHandlers()])
  ) as Record<SegmentManagerType, HandlerGroup>;
